export default "__VITE_ASSET__1d4b84c3__"